export default __webpack_public_path__ + "static/taco-a38468515393322a17f1b48e33c07a50.png";